import logo from './../../images/GoldfinderLogo.svg'
import symbol from './../../images/symbol.png'
import React, { useState, useEffect } from 'react';
import { app, auth } from '../../firebase/firebase';
import { Link, useNavigate } from 'react-router'
import { getCheckoutUrl, getPortalUrl } from "./../stripe/stripePayment.ts";
import { getPremiumStatus } from '../stripe/subscriptionStatus.ts';
import { LoadingOverlay } from '@achmadk/react-loading-overlay'
import FadeLoader from 'react-spinners/FadeLoader'

function SubscriptionPage() {

    //const { userLoggedIn } = useAuth()



    const navigate = useNavigate()

    const userName = auth.currentUser?.displayName;
    const email = auth.currentUser?.email;

    const [loading, setIsLoading] = useState(false);

    const manageSubscription = async () => {
        setIsLoading(true)
        const portalUrl = await getPortalUrl(app);
        setIsLoading(false)
        window.location.assign(portalUrl);
    };

    useEffect(() => {
        getPremiumStatus(app).then(e => {
            if (e) {
                manageSubscription();
            } else {
            }
        });
    }, [app, auth.currentUser?.uid]);



    const subscribeToYearly = async () => {
        const priceID = 'price_1R3nqEL2mQ2vApXC7e45LjJ8';
        setIsLoading(true)

        const checkoutUrl = await getCheckoutUrl(app, priceID);
        window.location.assign(checkoutUrl);
    }

    const subscribeToMonthly = async () => {
        const priceID = 'price_1R3npvL2mQ2vApXCNAVZ53fv';
        setIsLoading(true)

        const checkoutUrl = await getCheckoutUrl(app, priceID);
        window.location.assign(checkoutUrl);
    }

    return (
        <LoadingOverlay
            active={loading}
            spinner={<FadeLoader />}
            text='Redirecting to Payment Gateway.. please wait'
        >
            <div class="container py-3">

                <header>
                    <nav class="navbar navbar-expand-lg navbar-light border-bottom">
                        <div class="container-fluid">
                            <a class="navbar-brand" href="/">
                                <img style={{ margin: -17, marginTop: -30, marginBottom: -30 }} height="70" src={logo} />
                            </a>

                            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                                <span class="navbar-toggler-icon"></span>
                            </button>
                            <div style={{ marginLeft: 20 }} class="collapse navbar-collapse" id="navbarNav">
                                <ul class="navbar-nav">

                                    <li class="nav-item">
                                        <a class="nav-link active" aria-current="page" href="mailto:support@goldfinder.net.au">Contact</a>
                                    </li>


                                </ul>
                            </div>
                            <div class="justify-content-right">


                                <button type="button" onClick={() => { auth.signOut().then(() => { navigate('/login') }) }} class="btn btn-outline-primary me-2">Log Out</button>


                            </div>
                        </div>
                    </nav>


                    <div class="pricing-header p-3 pb-md-4 mx-auto text-center">
                        <h1 class="display-4 fw-normal text-body-emphasis">Subscription Pricing</h1>
                        <p class="fs-5 text-body-secondary">Get ready to revolutionise the way that you search for gold..</p>
                    </div>
                </header>
                <div style={{ height: '60vh' }} className=' align-items-center py-4 '>

                    <main>
                        <br />
                        <br />

                        <div class="row row-cols-1 align-items-center row-cols-md-2 mb-3 text-center">

                            <div class="col">
                                <div class="card mb-4 rounded-3 shadow-sm">
                                    <div class="card-header py-3">
                                        <h4 class="my-0 fw-normal">Monthly</h4>
                                    </div>
                                    <div class="card-body">
                                        <h1 class="card-title pricing-card-title">$4.99<small class="text-body-secondary fw-light"></small></h1>
                                        <ul class="list-unstyled mt-3 /faq/faqmb-4">
                                            <li><strong>For Prospectors who want to find nuggets.. sometimes</strong></li>
                                        </ul>
                                        <ul>
                                            <li>Realtime Soil Sample Search and Analysis</li>
                                            <li>Advanced Tenement Filtering</li>
                                            <li>Multiple Map layers ( 100k & 250k Geo,  Australian Topography)</li>
                                        </ul>
                                        <button type="button" onClick={() => subscribeToMonthly()} class="w-100 btn btn-lg btn-outline-primary">Subscribe</button>
                                    </div>
                                </div>
                            </div>
                            <div class="col">
                                <div class="card mb-4 rounded-3 shadow-sm">
                                    <div class="card-header py-3">
                                        <h4 class="my-0 fw-normal">Yearly</h4>
                                    </div>
                                    <div class="card-body">
                                        <h1 class="card-title pricing-card-title">$49<small class="text-body-secondary fw-light">/yr</small></h1>
                                        <ul class="list-unstyled mt-3 mb-4">
                                            <li><strong>18% Discount</strong></li>
                                            <li><strong>For Prospectors who want find nuggets.. regularly</strong></li>
                                        </ul>
                                        <ul>
                                            <li>Realtime Soil Sample Search and Analysis</li>
                                            <li>Advanced Tenement Filtering</li>
                                            <li>Multiple Map layers ( 100k & 250k Geo,  Australian Topography)</li>
                                        </ul>
                                        <button type="button" onClick={() => subscribeToYearly()} class="w-100 btn btn-lg btn-primary">Subscribe</button>
                                    </div>
                                </div>
                            </div>
                        </div>



                    </main>
                </div>
                <footer class="pt-4  pt-md-5 border-top">
                    <div class="row">
                        <div class="col-12 col-md">

                            <img width="24" src={symbol} />

                            <small class="d-block mb-3 text-body-secondary">&copy; 2025 Goldfinder</small>
                        </div>

                    </div>
                </footer>

            </div>
        </LoadingOverlay>

    );
}

export default SubscriptionPage;

